import React from "react";

export const ArrowDownLong = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fill="currentColor"
      d="M12.5 2a.5.5 0 01.5.5v16.17l4.44-4.45a.5.5 0 01.71 0l.7.71a.5.5 0 010 .71l-6.13 6.14a.75.75 0 01-.53.22h-.38a.77.77 0 01-.53-.22l-6.13-6.14a.5.5 0 010-.71l.71-.71a.49.49 0 01.7 0L11 18.67V2.5a.5.5 0 01.5-.5h1z"
    ></path>
  </svg>
);
